import { v4 as uuid } from 'uuid';

export const ChargeTypeConfigurationType = {
    Base: 1, Exception: 2,
};

export const ChargeTypeUnits = {
    Hours: 1,
    Flat: 2,
    Tonnage: 3
};

export const AccountCodingTypes = {
    Job: 1,
    TruckJob: 2,
    Department: 3
};

export class ChargeTypeViewModel {
    // Lookups
    billableOptions = [{ label: 'Yes', value: true }, { label: 'No', value: false }];

    increments = [{ value: '0.083', label: '5 minutes' }, { value: '0.167', label: '10 minutes' }, { value: '0.25', label: '15 minutes' }, { value: '0.5', label: '30 minutes' }];

    statuses = [];

    units = [];

    customers = [];

    resTypes = [{ label: 'Employee', value: 1 }, { label: 'Equipment', value: 2 }, { label: 'None', value: 3 }];

    resGroups = [];

    groups = [];

    equipmentTypes = [];

    // Validation
    errors = {};

    formValidated = false;

    validationMessage = '';

    // Object state
    originalData = null;

    chargeType = null;

    loading = true;

    showExceptionForm = false;

    showRateForm = false;

    selectedException = null;

    selectedRate = null;

    accountCodingTypeId = null;

    externalId = null;
}

export class ChargeTypeConfiguration {
    id = uuid();

    breakDescription = '';

    canBreak = false;

    cascadeChanges = false;

    chargeTypeId = null;

    chargeTypeConfigurationTypeId = null;

    customers = [];

    doesNotApply = false;

    increment = null;

    minimumPayUnits = null;

    maximumPayUnits = null;

    minimumBillUnits = null;

    maximumBillUnits = null;

    paidBreak = false;

    disallowNA = false;

    cancellationTimeThreshold = 60.0; // minutes

    cancellationBillQty = 2.0; // hours

    blockBillingCancel = false;

    blockPayrollCancel = false;
}

export class ContractChargeType {
    constructor(props) {
        this.id = props.id;
        this.contractId = props.id;
        this.chargeTypeId = props.chargeTypeId;
        this.chargeTypeEligibilityId = props.chargeTypeEligibilityId;
        this.order = props.order;
    }

    id = null;

    contractId = null;

    chargeTypeId = null;

    chargeTypeEligibilityId = null;

    order = null;

    description = '';

    chargeUnits = '';

    employees = '';

    equipment = '';

    billable = '';
}

export class ChargeType {
    baseConfig = { ...new ChargeTypeConfiguration(), chargeTypeConfigurationTypeId: 1 /* base */ };

    companyId = null;

    companyName = '';

    description = '';

    groups = [];

    isBillable = false;

    equipment = [];

    equipmentFlat = '';

    exceptionAllowed = false;

    exceptions = [];

    rates = [];

    id = null;

    information = '';

    statusId = 1; // default to active

    statusName = '';

    rolesFlat = '';

    unitsId = null;

    unitsName = '';

    resourceTypeId = null;

    resourceGroupId = null;

    costCodeId = null;

    departmentId = null;

    isRepair = false;

    isExempt = false;
}

export const _ContractChargeTypeEligibility = {
    Required: 1,
    Optional: 2,
    DoNotUse: 3,
};



